 

// footer1.js

export const footer1 = (formData, message, createPhoneNum) => `
<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width,initial-scale=1" />
  <title>html_signature</title>
  <style>
    @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");
    body {
      overflow: hidden;
      width: 560px;
      min-width: 560px;
    }
  </style>
</head>

<body>
  <table width="560" border="0" cellspacing="0" cellpadding="0" border-spacing="0" style="
    width: 560px;
    font-family: Montserrat, sans-serif;
    mso-line-height-rule: exactly;
    border-collapse: collapse;
    -webkit-text-size-adjust: none;
  ">
    <style>
      .ii a[href] {
        color: black !important;
        text-decoration: none !important;
      }
    </style>
    <tr>
      <td width="560" style="padding-bottom: 5px !important; width: 560px">
        <table border="0" cellspacing="0" cellpadding="0" border-spacing="0">
          <tr>
            <td width="130" valign="top" style="text-align: left; width: 130px">
              <table border="0" cellspacing="0" cellpadding="0">
                <tr>
                  <td width="130" valign="top" style="text-align: center; width: 130px">
                    <img border="0" width="120" height="144" src="${message}" alt="photo"
                      style="width: 120px; height: 144px;" />
                  </td>
                </tr>
              </table>
            </td>
            <td width="270" style="padding-left: 10px; width: 270px; vertical-align: top">
              <table border="0" cellspacing="0" cellpadding="0">
                <tr>
                  <td height="10" style="font-size: 1px; line-height: 1px"></td>
                </tr>
                <tr>
                  <td width="270" style="padding-bottom: 7px; line-height: 11pt; width: 230px;" border="0"
                    cellspacing="0" cellpadding="0">
                    <p style="margin: 0; font-size: 16px !important;">
                      <span style="
                        font-family: Montserrat, sans-serif;
                        font-size: 16px !important;
                        color: #000;
                        font-weight: 700;
                      ">${formData.name || "WPISZ IMIE I NAZWISKO"}</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="270" style="padding-bottom: 0px !important; line-height: 13px !important; width: 230px;"
                    border="0" cellspacing="0" cellpadding="0">
                    <p style="margin: 0">
                      <span style="
                        font-family: Montserrat, sans-serif;
                        font-size: 13px !important;
                        color: #e85511;
                        font-style: italic;
                      ">${formData.job || "WPISZ STANOWISKO"}</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td width="270" style="width: 270px; padding-top: 3px !important">
                    <table border="0" cellspacing="0" cellpadding="0">
                      <tr>
                        <td width="270" style="line-height: 8pt; width: 270px">
                          <table>
                            <tr>
                              <td width="25" style="padding-left: 3px!important">
                                <p style="margin: 0.1px">
                                  <img border="0" width="12" src="https://balans.agency/images/cell_iaobft.png"
                                    alt="cell" style="border: 0; vertical-align: middle; width: 12px;" />
                                </p>
                              </td>
                              <td width="245">
                                <p style="margin: 0.1px">
                                  <a href="tel:+48${formData.phone?.toString() || ''}" style="
                                    font-family: Montserrat, sans-serif;
                                    font-size: 13px !important;
                                    color: #000 !important;
                                    text-decoration: none !important;
                                    vertical-align: middle;
                                  ">+48 ${createPhoneNum ? createPhoneNum(formData.phone) : "000 000 000"}</a>
                                </p>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td width="270" style="line-height: 8pt; width: 270px; padding-top: 4px;">
                          <table>
                            <tr>
                              <td width="25">
                                <p style="margin: 0.1px">
                                  <img border="0" width="17" src="https://balans.agency/images/mail_fssijs.png"
                                    alt="mail" style="border: 0; vertical-align: middle; width: 17px;" />
                                </p>
                              </td>
                              <td width="245">
                                <p style="margin: 0.1px">
                                  <a href="mailto:${formData.mail}" style="
                                    font-family: Montserrat, sans-serif;
                                    font-size: 13px !important;
                                    color: #000 !important;
                                    text-decoration: none !important;
                                    vertical-align: middle;
                                  ">${formData.mail || "WPISZ MAIL"}</a>
                                </p>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td width="270" style="line-height: 8pt; width: 270px; padding-top: 4px;">
                          <table>
                            <tr>
                              <td width="25" style="width:25px !important">
                                <p style="margin: 0.1px">
                                  <img border="0" width="22" src="https://balans.agency/images/teams.png" alt="teams"
                                    style="border: 0; vertical-align: middle; width: 22px !important; max-height: 22px !important;" />
                                </p>
                              </td>
                              <td width="245">
                                <p style="margin: 0.1px">
                                  <a href="https://teams.microsoft.com/l/chat/0/0?users=${formData.mail}" style="
                                    font-family: Montserrat, sans-serif;
                                    font-size: 13px !important;
                                    color: #000 !important;
                                    text-decoration: none !important;
                                    vertical-align: middle;
                                  ">Napisz do mnie!</a>
                                </p>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
            <td width="160" style="width: 160px; vertical-align: top">
              <table border="0" cellspacing="0" cellpadding="0" width="230">
                <tr>
                  <td width="160">
                    <table border="0" cellspacing="0" cellpadding="0">
                      <tr>
                        <td width="160">
                          <img border="0" width="140" src="https://balans.agency/images/footerLogo.png" alt="logo"
                            style="border: 0; vertical-align: middle; width: 140px;" />
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr><td height="1" style="font-size: 0px; line-height: 0px"></td></tr>
                <tr>
                  <td width="160">
                    <table border="0" cellspacing="0" cellpadding="0">
                      <tr>
                        <td width="25" style="width:25px !important; height:15px !important;">
                          <p style="margin: 0.1px; width: 12px !important;">
                            <img border="0" width="12" src="https://balans.agency/images/place_dplvfl.png" alt="place"
                              style="border: 0; vertical-align: middle; width: 12px !important; max-width:15px !important;" />
                          </p>
                        </td>
                        <td width="135">
                          <p style="margin: 0.1px">
                            <span style="
                              font-family: Montserrat, sans-serif;
                              font-size: 13px !important;
                              color: #000;
                            ">ul. Wąchocka 1F</span>
                          </p>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td width="160">
                    <table border="0" cellspacing="0" cellpadding="0">
                      <tr>
                        <td width="25" style="font-size: 1px !important; line-height: 1px !important;width:25px !important;"></td>
                        <td width="135">
                          <p style="margin: 0.1px">
                            <span style="
                              font-family: Montserrat, sans-serif;
                              font-size: 13px !important;
                              color: #000;
                            ">03-934 Warszawa</span>
                          </p>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td width="150" style="padding-top: 5px">
                    <table border="0" cellspacing="0" cellpadding="0">
                      <tr>
                        <td width="25" style="width:25px !important; height:15px !important;">
                          <p style="margin: 0.1px; width: 12px !important;">
                            <img border="0" width="17" src="https://balans.agency/images/website_vatczt.png"
                              alt="website" style="border: 0; vertical-align: middle; width: 17px !important;" />
                          </p>
                        </td>
                        <td width="140">
                          <p style="margin: 5px; margin-left:2px">
                            <a href="https://balans.agency/" target="_blank" style="
                              font-family: Montserrat, sans-serif;
                              font-size: 13px !important;
                              color: #000 !important;
                              text-decoration: none !important;
                              vertical-align: middle;
                            ">https://balans.agency</a>
                          </p>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </td>
    </tr>
    <tr>
      <td style="
        font-family: Montserrat, sans-serif;
        font-size: 8px !important;
        color: #E85511;
        text-decoration: none;
        vertical-align: middle;
      ">
        <i>
          Rozumiem, jak ważny jest balans między pracą a życiem prywatnym, dlatego korzystam z elastyczności moich godzin
          pracy.
          <br />
          Proszę, nie czuj się w obowiązku, by odpowiadać na ten e-mail poza swoimi godzinami pracy.
        </i>
      </td>
    </tr>
  </table>
  <table width="700" border="0" cellspacing="0" cellpadding="0" border-spacing="0" style="
    width: 700px;
    font-family: 'Nunito Sans', Poppins, sans-serif;
    mso-line-height-rule: exactly;
    border-collapse: collapse;
    -webkit-text-size-adjust: none;
  ">
    <tr>
      <td width="700" style="line-height: 0; padding-top: 5px">
        <img valign="middle" border="0" width="700" height="1"
          src="https://balans.agency/images/63c1fb3f-52be-8923-ea1b-39f689d2ea33.png" alt="line"
          style="width: 700px; height: 1px" />
      </td>
    </tr>
  </table>
</body>

</html>
`;


// footer2.js

export const footer2 = (formData, message, createPhoneNum) => `
<!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN">
<html>
<head>
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
  <title>Email Signature</title>
  <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500&display=swap" rel="stylesheet">
</head>
<body style="margin:0; padding-top:15px; padding-left:10px; padding-right:10px;">
  <table width="500" border="0" cellspacing="0" cellpadding="0" style="
    border-collapse:collapse;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size:14px;
    line-height:18px;
    color:#000000;
    mso-line-height-rule: exactly;
    -webkit-text-size-adjust:none;
  ">
    <tr>
      <!-- Kolumna 1: zdjęcie -->
      <td width="180" valign="top" align="center" style="padding:0 5px 0 0;">
        <img src="${message}" alt="${formData.name || "Twoje imię i nazwisko"}" width="120" style="display:block; border-radius:0px;">
      </td>

      <!-- Kolumna 2: dane kontaktowe + legal -->
      <td width="240" valign="top" style="padding:0 0px;">
        <table border="0" cellpadding="0" cellspacing="0" style="
          border-collapse:collapse;
          width:100%;
          font-family: 'Montserrat', Arial, Helvetica, sans-serif;
          font-size:14px;
          line-height:15px;
          color:#000000;
        ">
          <tr>
            <td style="font-size:14px; font-weight:bold; color:#000000; padding-bottom:3px;">
              ${formData.name || "WPISZ IMIĘ I NAZWISKO"}
            </td>
          </tr>
          <tr>
            <td style="font-size:10px; font-style:italic; color:#f15a24; padding-bottom:6px;">
              ${formData.job || "WPISZ STANOWISKO"}
            </td>
          </tr>
          <tr>
            <td style="padding-bottom:7px;">
              <table border="0" cellspacing="0" cellpadding="0" style="border-collapse:collapse;">
                <tr>
                  <td width="18" valign="middle">
                    <img src="https://balans.agency/images/stopka/tel.png" alt="phone" width="9" style="display:block; padding-right:5px !important; font-weight:300;">
                  </td>
                  <td>
                    <a href="tel:+48${formData.phone?.toString() || ''}" style="font-size:10px; color:#000000; text-decoration:none;">
                      +48 ${createPhoneNum ? createPhoneNum(formData.phone) : "000 000 000"}
                    </a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td style="padding-bottom:7px;">
              <table border="0" cellspacing="0" cellpadding="0" style="border-collapse:collapse;">
                <tr>
                  <td width="18" valign="middle">
                    <img src="https://balans.agency/images/stopka/mail.png" alt="mail" width="13" style="display:block; padding-right:5px !important;">
                  </td>
                  <td>
                    <a href="mailto:${formData.mail}" style="font-size:10px; color:#000000; text-decoration:none;">
                      ${formData.mail || "WPISZ MAIL"}
                    </a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Legal -->
          <tr>
            <td style="font-size:4.5pt; font-weight:500; line-height:6.5pt; color:#f15a24; padding-top:5px;">
              <table border="0" cellpadding="0" cellspacing="0" role="presentation" width="100%" style="border-collapse:collapse;">
                <tr>
                  <td height="1" style="background-color:#f15a24; font-size:0; line-height:0;">&nbsp;</td>
                </tr>
              </table>
              <br/>
              <i>
                Rozumiem, jak ważny jest balans między pracą a życiem prywatnym,
                dlatego korzystam z elastyczności moich godzin pracy.
                Proszę, nie czuj się w obowiązku, by odpowiadać na ten e-mail poza swoimi godzinami pracy.
              </i>
            </td>
          </tr>
        </table>
      </td>

      <!-- Kolumna 3: logo + adres + sociale -->
      <td width="100" valign="top" align="center">
        <table border="0" cellpadding="0" cellspacing="0" style="border-collapse:collapse;">
          <tr>
            <td align="center" style="padding-bottom:15px;">
              <img src="https://balans.agency/images/stopka/balansLogo.png" alt="BALANS Agency" width="110" style="display:block;">
            </td>
          </tr>
          <tr>
            <td align="center" style="font-size:10px; color:#000000; line-height:12px; padding-bottom:10px;">
              <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;">
                <tr>
                  <td valign="top" style="padding-right:6px;">
                    <img src="https://balans.agency/images/stopka/location.png" width="12" alt="Lokalizacja" style="display:block; border:0; outline:none; text-decoration:none;">
                  </td>
                  <td valign="middle" style="
                    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
                    font-size:10px;
                    line-height:12px;
                    color:#000000;
                    padding-bottom:5px;
                  ">
                    ul. Wąchocka 1F<br>
                    03-934 Warszawa
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr>
            <td align="center">
              <a href="https://www.linkedin.com/company/balans-agency/" style="text-decoration:none; margin-right:10px;">
                <img src="https://balans.agency/images/stopka/link.png" alt="LinkedIn" width="24" style="display:inline-block;">
              </a>
              <a href="https://www.instagram.com/balans_agency/" style="text-decoration:none; margin-right:10px;">
                <img src="https://balans.agency/images/stopka/ig.png" alt="Instagram" width="24" style="display:inline-block;">
              </a>
              <a href="https://www.youtube.com/@BALANS.agency" style="text-decoration:none;">
                <img src="https://balans.agency/images/stopka/web.png" alt="Website" width="24" style="display:inline-block;">
              </a>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>
`;



/*

<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width,initial-scale=1" />
    <title>html_signature</title>
    <style>
        @import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap");

        body {
            overflow: hidden;
            width: 560px;
            min-width: 560px;

        }

    </style>
</head>

<body>
    <table width="560" border="0" cellspacing="0" cellpadding="0" border-spacing="0" style="
      
        width: 560px;
        font-family: Montserrat, sans-serif;
        mso-line-height-rule: exactly;
        border-collapse: collapse;
        -webkit-text-size-adjust: none;
      ">
      <style> 

        .ii a[href] {
         color:black !important;
         text-decoration:none !important;
        }
      </style>
        <tr>
            <td width="560" style="padding-bottom: 5px !important; width: 560px">
                <table border="0" cellspacing="0" cellpadding="0" border-spacing="0">
                    <tr>
                        <td width="130" valign="top" style="text-align: left; width: 130px">
                            <table border="0" cellspacing="0" cellpadding="0">
                                <tr>
                                    <td width="130" valign="top" style="text-align: center; width: 130px">
                                        <img border="0" width="120" height="144" src="${message}" alt="photo" style="width: 120px; height: 144px;" />
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td width="270" style="padding-left: 10px; width: 270px; vertical-align: top">
                            <table border="0" cellspacing="0" cellpadding="0">
                                <tr>
                                    <td height="10" style="font-size: 1px; line-height: 1px"></td>
                                </tr>
                                <tr>
                                    <td width="270" style="
                        padding-bottom: 7px;
                        line-height: 11pt;
                        width: 230px;
                      " border="0" cellspacing="0" cellpadding="0">
                                        <p style="margin: 0;   font-size: 16px !important;">
                                            <span style="
                            font-family: Montserrat, sans-serif;
                            font-size: 16px !important;
                            color: #000;
                            font-weight: 700;
                          ">${formData.name || "WPISZ IMIE I NAZWISKO"}</span>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="270" style="
                        padding-bottom: 0px !important;
                        line-height: 13px !important;
                        width: 230px;
                      " border="0" cellspacing="0" cellpadding="0">
                                        <p style="margin: 0">
                                            <span style="
                            font-family: Montserrat, sans-serif;
                            font-size: 13px !important;
                            color: #e85511;
                            font-style: italic;
                          ">${formData.job || "WPISZ STANOWISKO"}</span>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="270" style="width: 270px; padding-top: 3px !important">
                                        <table border="0" cellspacing="0" cellpadding="0">
                                            <tr>
                                                <td width="270" style="line-height: 8pt; width: 270px">
                                                    <table>
                                                        <tr>
                                                            <td width="25" style="padding-left: 3px!important">
                                                                <p style="margin: 0.1px">
                                                                    <img moz-do-not-send="true" border="0" width="12" height="" src="https://balans.agency/images/cell_iaobft.png" alt="cell" style="
                                        border: 0;
                                        vertical-align: middle;
                                        width: 12px;
                                      " />
                                                                </p>
                                                            </td>
                                                            <td width="245">
                                                                <p style="margin: 0.1px">
                                                                    <a href="tel:+48${formData.phone.toString()}" style="
                                        font-family: Montserrat, sans-serif;
                                        font-size: 13px !important;
                                        color: #000 !important;
                                        text-decoration: none !important;
                                        vertical-align: middle;
                                      ">+48 ${ createPhoneNum(formData.phone) || "000 000 000"}</a>
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="270" style="
                              line-height: 8pt;
                              width: 270px;
                              padding-top: 4px;
                            ">
                                                    <table>
                                                        <tr>
                                                            <td width="25">
                                                                <p style="margin: 0.1px">
                                                                    <img moz-do-not-send="true" border="0" width="17" height="" src="https://balans.agency/images/mail_fssijs.png" alt="mail" style="
                                        border: 0;
                                        vertical-align: middle;
                                        width: 17px;
                                      " />
                                                                </p>
                                                            </td>
                                                            <td width="245">
                                                                <p style="margin: 0.1px">
                                                                    <a href="mailto:${formData.mail}" style="
                                        font-family: Montserrat, sans-serif;
                                        font-size: 13px !important;
                                        color: #000 !important;
                                        text-decoration: none !important;
                                        vertical-align: middle;
                                      ">${ formData.mail || "WPISZ MAIL"}</a>
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="270" style="
                              line-height: 8pt;
                              width: 270px;
                              padding-top: 4px;
                            ">
                                                    <table>
                                                        <tr>
                                                            <td width="25" style="width:25px !important">
                                                                <p style="margin: 0.1px">
                                                                    <img moz-do-not-send="true" border="0" width="17" height="" src="https://balans.agency/images/teams.png" alt="skype" style="
                                        border: 0;
                                        vertical-align: middle;
                                        width: 22px !important;
                                        max-height: 22px !important;
                                      " />
                                                                </p>
                                                            </td>
                                                            <td width="245">
                                                                <p style="margin: 0.1px">
                                                                    <a href="https://teams.microsoft.com/l/chat/0/0?users=${formData.mail}" style="
                                        font-family: Montserrat, sans-serif;
                                        font-size: 13px !important;
                                        color: #000 !important;
                                        text-decoration: none !important;
                                        vertical-align: middle;
                                      ">Napisz do mnie!</a>
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td width="160" style="width: 160px; vertical-align: top">
                            <table border="0" cellspacing="0" cellpadding="0" width="230">
                                <tr>
                                    <td width="160">
                                        <table border="0" cellspacing="0" cellpadding="0">
                                            <tr>
                                                <td width="160">
                                                    <img moz-do-not-send="true" border="0" width="140" height="" src="https://balans.agency/images/footerLogo.png" alt="logo" style="
                                border: 0;
                                vertical-align: middle;
                                width: 140px;
                              " />
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td height="1" style="font-size: 0px; line-height: 0px"></td>
                                </tr>
                                <tr>
                                    <td width="160">
                                        <table border="0" cellspacing="0" cellpadding="0">
                                            <tr>
                                                <td width="25" style="width:25px !important; height:15px !important;">
                                                    <p style="margin: 0.1px;  width: 12px !important;">
                                                        <img moz-do-not-send="true" border="0" width="12" height="20" src="https://balans.agency/images/place_dplvfl.png" alt="skype" style="
                                  border: 0;
                                  vertical-align: middle;
                                  width: 12px !important;
                                  max-width:15px !important;
                                " />
                                                    </p>
                                                </td>
                                                <td width="135">
                                                    <p style="margin: 0.1px">
                                                        <span style="
                                  font-family: Montserrat, sans-serif;
                                  font-size: 13px !important;
                                  color: #000;
                                  text-decoration: none;
                                  vertical-align: middle;
                                ">ul. Wąchocka 1F</span>
                                                    </p>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="160">
                                        <table border="0" cellspacing="0" cellpadding="0">
                                            <tr>
                                                <td width="25" style="font-size: 1px !important;; line-height: 1px !important;width:25px !important;"></td>
                                                <td width="135">
                                                    <p style="margin: 0.1px">
                                                        <span style="
                                  font-family: Montserrat, sans-serif;
                                  font-size: 13px !important;
                                  color: #000;
                                  text-decoration: none;
                                  vertical-align: middle;
                                ">03-934 Warszawa</span>
                                                    </p>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="150" style="padding-top: 5px">
                                        <table border="0" cellspacing="0" cellpadding="0">
                                            <tr>
                                                <td width="25" style="width:25px !important; height:15px !important;">
                                                    <p style="margin: 0.1px;  width: 12px !important;">
                                                        <img moz-do-not-send="true" border="0" width="17" height="" src="https://balans.agency/images/website_vatczt.png" alt="website_vatczt" style="
                                  border: 0;
                                  vertical-align: middle;
                                  width: 17px !important;
                                " />
                                                    </p>
                                                </td>
                                                <td width="140">
                                                    <p style="margin: 5px; margin-left:2px">
                                                        <a href="https://balans.agency/" target="_blank" style="
                                 
                                  font-family: Montserrat, sans-serif;
                                  font-size: 13px !important;
                                  color: #000 !important;
                                  text-decoration: none !important;
                                  vertical-align: middle;
                                "> <span> https://balans.agency </span> </a>
                                                    </p>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
        <tr>
            <td style="
        font-family: Montserrat, sans-serif;
        font-size: 8px !important;
        color: #E85511;
        text-decoration: none;
        vertical-align: middle;
      ">
                <i>
                    Rozumiem, jak ważny jest balans między pracą a życiem prywatnym, dlatego korzystam z elastyczności moich godzin pracy.
                    <br />
                    Proszę, nie czuj się w obowiązku, by odpowiadać na ten e-mail poza swoimi godzinami pracy.
                </i>

            </td>
        </tr>
    </table>
</body>

</html>
<table width="700" border="0" cellspacing="0" cellpadding="0" border-spacing="0" style="
    width: 700px;
    font-family: 'Nunito Sans', Poppins, sans-serif;
    mso-line-height-rule: exactly;
    border-collapse: collapse;
    -webkit-text-size-adjust: none;
  ">
    <tr>
        <td width="700" style="line-height: 0; padding-top: 5px">
            <img moz-do-not-send="true" valign="middle" border="0" width="700" height="1" src="https://balans.agency/images/63c1fb3f-52be-8923-ea1b-39f689d2ea33.png" alt="line" style="width: 700px; height: 1px" />

        </td>
    </tr>
</table>

*/